import {connect} from 'react-redux';

import Home from '../pages/home/Home';

const _mapStateToProps = ({app}) => ({
    isLoading: app.isLoading,
});

export default connect(
    _mapStateToProps
)(Home);
